/**
 * Canonical message context implementation.
 *
 * This is the source of truth. `@post-office/message-context` re-exports from here.
 * Consumers should import via:
 *   import { useMessageContext, MessageContextProvider } from '@atlassian/post-office-context/message-context';
 */
import { type Context, createContext, type Provider, useContext } from 'react';

export type MessageCategory = 'Transactional' | 'Marketing' | 'Engagement';

export type MessageContextData = {
	messageInstanceId?: string;
	messageTemplateId?: string;
	messageCategory?: MessageCategory;
	transactionAccountId?: string;
	analyticsDetails?: Record<string, string | number | boolean>;
	triggerId?: string;
	messageCreationType?: 'implicit' | 'explicit';
	product?: string;
	journeyId?: string;
	journeyTriggerId?: string;
	configSetId?: string;
};

const initialValue: MessageContextData = {};

export const MessageContext: Context<MessageContextData> =
	createContext<MessageContextData>(initialValue);

export const MessageContextProvider: Provider<MessageContextData> = MessageContext.Provider;

export const useMessageContext = (): MessageContextData => useContext(MessageContext);
